 
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
  // {
  //     id : 'dashboard',
  //     title : 'Dashboard',
  //     type : 'basic',
  //     icon : 'heroicons_outline:home',
  //     link : '/',
  //     exactMatch: true

  // },

  {
    id: 'Dashboard',
    title: 'Dashboard',
    type: 'basic',
    icon: 'heroicons_outline:home', //academic-cap?
    link: '/dashboard',
    exactMatch: true,
  },
  // {
  //   id: 'portal.ai.quote-request',
  //   title: 'AI Quote Request',
  //   type: 'basic',
  //   icon: 'heroicons_outline:sparkles',
  //   link: '/ai-quote-request',
  //   exactMatch: true,
  // },
  {
    id: 'home.inbox',
    title: 'Inbox',
    type: 'basic',
    icon: 'heroicons_outline:inbox-stack',
    link: '/inbox',
    badge: {
      title: '8',
      classes: 'px-2 bg-emerald-300 text-black rounded',
    },
  },

    {
      id: 'sales.quote-requests.old',
      title: 'Quote Requests',
      subtitle: 'Manage Quotes',
      type: 'group',
      icon: 'mat_outline:request_quote',
      children:[
        {
        id: 'sales.quote-requests.new',
        title: 'In Progress Quotes',
        type: 'basic',
        icon: 'mat_outline:request_quote',
        link: '/quote-requests',
        exactMatch: true,
        badge: {
          title: '-1',
          classes: 'px-2 bg-emerald-300 text-black rounded',
        },
      },
      {
        id: 'sales.quote-requests.archived',
        title: 'Archived Quotes',
        type: 'basic',
        icon: 'feather:archive',
        link: '/quote-requests/shipments/Archived-Shipments',
        exactMatch: true,
        badge: {
          title: '0',
          classes: 'px-2 bg-emerald-300 text-black rounded',
        },
      },
      ]
    },
  {
    id: 'dashboards',
    title: 'Shipments',
    subtitle: 'Book & Manage Freight Operations',
    type: 'group',
    icon: 'heroicons_outline:home',
    children: [
      {
        id: 'sales.quote-requests.operationInProgress',
        title: 'In Progress Shipments',
        type: 'basic',
        icon: 'mat_outline:directions_boat',
        link: '/quote-requests/shipments/All-In-Progress-Shipments',
        badge: {
          title: '0',
          classes: 'px-2 bg-emerald-300 text-black rounded',
        },
      },
      {
        id: 'operations.completed',
        title: 'Completed Shipments',
        type: 'basic',
        icon: 'mat_outline:done_outline',
        link: '/quote-requests/shipments/Completed-Shipments',
        badge: {
          title: '0',
          classes: 'px-2 bg-emerald-300 text-black rounded',
        },
      },
    ],
  },
  {
    id: 'accounting',
    title: 'My Finances',
    subtitle: 'View Accounting Documents and Reports',
    type: 'group',
    icon: 'mat_outline:account_balance',
    children: [
      {
        id: 'accounting.invoice.list',
        title: 'Invoices',
        type: 'basic',
        icon: 'mat_outline:receipt',
        link: '/accounting/invoice/list',
      },
      {
        id: 'accounting.receipt-voucher.list',
        title: 'Receipt Vouchers',
        type: 'basic',
        icon: 'mat_outline:attach_money',
        link: '/accounting/receipt-voucher/list',
      },
      //   {
      //     id: 'accounting.credit-note.list',
      //     title: 'Credit Notes',
      //     type: 'basic',
      //     icon: 'mat_outline:note_add',
      //     link: '/accounting/credit-note/list',
      //   },
        // {
        //   title: 'Statement Of Accounts',
        //   type: 'basic',
        //   icon: 'mat_outline:description',
        //   link: '/accounting/statement-of-accounts/new',
        // },
    ],
  },

  //   {
  //     id: 'accounting',
  //     title: 'Financial Operations',
  //     subtitle: 'View Accounting Documents and Reports',
  //     type: 'group',
  //     children: [
  //       {
  //         id: 'accounting',
  //         title: 'Accounting',
  //         type: 'collapsable',
  //         icon: 'mat_outline:account_balance',
  //         children: [
  //           {
  //             id: 'accounting.sc',
  //             title: 'Customer Invoices',
  //             type: 'basic',
  //             icon: 'mat_outline:receipt',
  //             link: '/accounting/invoice/list',
  //           },
  //           {
  //             id: 'accounting.rv',
  //             title: 'Receipt Vouchers',
  //             type: 'basic',
  //             icon: 'mat_outline:attach_money',
  //             link: '/accounting/receipt-voucher/list',
  //           },
  //           {
  //             id: 'accounting.cn',
  //             title: 'Credit Notes',
  //             type: 'basic',
  //             icon: 'mat_outline:note_add',
  //             link: '/accounting/credit-note/list',
  //           },
  //         ],
  //       },
  //       {
  //         id: 'accounting.sps',
  //         title: 'Shipment Profit Summary',
  //         type: 'basic',
  //         icon: 'mat_outline:account_balance_wallet',
  //         link: '/accounting/profit-summary',
  //       },
  //       {
  //         id: 'accounting.tb',
  //         title: 'Trial Balance',
  //         type: 'basic',
  //         icon: 'app:balance',
  //         link: '/accounting/trial-balance',
  //       },
  //       {
  //         title: 'Statement Of Accounts',
  //         type: 'basic',
  //         icon: 'mat_outline:description',
  //         link: '/accounting/statement-of-accounts/list',
  //       },
  //     ],
  //   },
];
export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
